// ============= SHARED CONSTANTS =============

export const COLORS = {
  sage: '#9CAF88',
  dustyRose: '#C9A9A6', 
  lavender: '#B4A7C7',
  seafoam: '#8FBCBB',
  warmTaupe: '#C4B7A6',
  mutedBlue: '#8BA4B4',
  stone: '#A8A29E',
};

export const MUTED_PALETTE = Object.values(COLORS);
